import type { ReactNode } from "react";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";

type Props = {
  isLoading: boolean;
  value: string;
  title: string;
  icon: ReactNode;
  explanationHint: ReactNode;
};

export const PointsValue = ({
  isLoading,
  value,
  title,
  icon,
  explanationHint,
}: Props) => (
  <ValueTile
    isLoading={isLoading}
    icon={icon}
    title={title}
    value={value}
    variant="space"
    explanationHint={explanationHint}
  />
);
